import greenloopLogo from "../assets/greenloop-logo.png";
import sasaLogo from "../assets/sasa-logo.png";
// import defaultLogo from "../assets/default-logo.png"; // optional
import sasaBackground from "../assets/sasabackground.png";
import mnklogo from "../assets/m&klogo.png";
import mnkbackground from "../assets/m&Kbackground.jpg";
import confluenceLogo from "../assets/confluence-logo.JPG";
import confluenceBackground from "../assets/confluencebg.png";
import modisaneLogo from "../assets/modisanelogo.PNG";
import lema_logo from "../assets/lema-logo-white.png";

const companies = {
  greenloop: {
    name: "Green Loop ESG Consultants",
    primaryColor: "#133d3f",
    secondaryColor: "#FFC107",
    backgroundColor: "#FFFFFF",
    paperBackground: "#FFFFFF",
    textColor: "#212121",
    secondaryTextColor: "#757575",
    fontFamily: "Arial, sans-serif",
    buttonTextColor: "#FFFFFF",
    buttonBorderRadius: "20px",
    logo: greenloopLogo,
    emailSender: "businesscardsbotswana@gmail.com",
    website: "https://greenloop.co.bw/",
    layout: "default",
  },

  sasainteriors: {
    name: "Sasa Interiors",
    primaryColor: "#000000",
    layout: "elegant", // ✅ matches getLayout key
    secondaryColor: "#FFFFFF",
    backgroundColor: "#f8f8f8",
    paperBackground: "#ffffff",
    textColor: "#000000",
    secondaryTextColor: "#7e7e7e",
    fontFamily: "Century Gothic, sans-serif",
    buttonTextColor: "#000000",
    buttonBorderRadius: "12px",
    logo: sasaLogo,
    emailSender: "businesscardsbotswana@gmail.com",
    website: "https://sasainteriors-bw.com/",
    socialIcons: {
      facebook: "https://www.facebook.com/sasainteriorsandhomeware",
      linkedin: "https://www.linkedin.com/company/sasa-interiors-and-homeware/",
      instagram:
        "https://www.instagram.com/sasainteriorsandhomeware/?igsh=aWM5ZXgzemtteHJi",
    },
    backgroundImage: sasaBackground,
  },

  // NOTE: keep this key EXACTLY how you use it in the route /:companyName
  minchinkelly: {
    name: "Michin and Kelly",
    primaryColor: "#0076be",
    secondaryColor: "#2C5B68",
    backgroundColor: "#1C1C1C",
    paperBackground: "#333333",
    textColor: "#FFFFFF",
    secondaryTextColor: "rgba(255, 255, 255, 0.7)",
    fontFamily: "Montserrat, sans-serif",
    buttonTextColor: "#FFFFFF",
    buttonBorderRadius: "16px",
    logo: mnklogo,
    emailSender: "contact@michinandkelly.com",
    website: "https://minchinkelly.bw/",
    layout: "michinAndkelly", // ✅ matches getLayout key
    backgroundImage: mnkbackground,
    socialIcons: {
      facebook: "https://facebook.com/minchinkellybotswana",
      linkedin: "https://www.linkedin.com/company/minchin-kelly-botswana/",
    },
    // example: hide bio, show profileUrl via the global form (optional)
    // formFields: { bio: { show: false }, profileUrl: { show: true } },
  },

  confluencesafari: {
    name: "Confluence Tours & Safari",
    primaryColor: "#c29b5c", // gold accent
    secondaryColor: "#8c6a3b", // deep brown
    backgroundColor: "#1f1f1f", // page bg
    paperBackground: "#2d2419", // lower section bg (D in layout)
    textColor: "#FFFFFF",
    secondaryTextColor: "rgba(255, 255, 255, 0.85)",
    fontFamily: "'Montserrat', sans-serif",
    buttonTextColor: "#FFFFFF",
    buttonBorderRadius: "20px",
    logo: confluenceLogo,
    emailSender: "info@confluencetours.com",
    website: "https://confluencetours.co.bw/",
    layout: "confluencesafari", // ✅ CHANGED to match getLayout key
    backgroundImage: confluenceBackground,
    socialIcons: {
      facebook:
        "https://www.facebook.com/p/Confluence-Tours-Safari-100076410278363/",
      instagram: "https://www.instagram.com/confluence_tours_safari/",
      tiktok: "https://www.tiktok.com/@confluencetoursbw",
    },
    // optional: remove bio from the global form for this company
    formFields: { bio: { show: false } },
  },

  modisanelaw: {
    name: "Modisane Law",
    layout: "modisaneLaw", // ⚠️ be sure to register this in getLayout()
    primaryColor: "#E9C874",
    backgroundColor: "#0E0E0E",
    paperBackground: "#151515",
    textColor: "#FFFFFF",
    fontFamily: "Montserrat, sans-serif",
    logo: modisaneLogo,
    website: "https://modisane.law/",
    profileBaseUrl: "https://modisanelaw.example.com/team/",
    socialIcons: {
      linkedin: "https://www.linkedin.com/company/modisane-law/",
    },
    // show Profile URL in global form
    formFields: {
      profileUrl: { show: true, required: true },
      bio: { show: false },
    },
  },
  "lema-systems": {
    name: "Le-Ma Systems",
    legalName: "Le-Ma Systems Botswana",
    layout: "lema", // ⚠️ matches getLayout key
    primaryColor: "#32C85A",
    secondaryColor: "#00B8FF",
    backgroundColor: "#020812",
    paperBackground: "rgba(2, 12, 24, 0.72)",
    textColor: "#FFFFFF",
    mutedTextColor: "rgba(255,255,255,0.68)",
    fontFamily: "Montserrat, sans-serif",
    logo: lema_logo,
    website: "https://lema.systems",
    footerSlogan:
      "Building Scalable Digital Systems for Businesses and Institutions",
    tagline: "Redefining the digital age through technology that empowers.",
    socialIcons: {
      linkedin: "https://www.linkedin.com/company/lema-systems/",
    },
    formFields: {
      profileUrl: { show: false },
      bio: { show: true, required: false },
      baseLocation: { show: true, required: false },
      company: { show: true, required: false },
      department: { show: true, required: false },
      experience: { show: true, required: false },
      languages: { show: true, required: false },
      mission: { show: true, required: false },
      vision: { show: true, required: false },
    },
  },

  default: {
    name: "Default Company",
    primaryColor: "#4CAF50",
    secondaryColor: "#FFC107",
    backgroundColor: "#FFFFFF",
    paperBackground: "#FFFFFF",
    textColor: "#212121",
    secondaryTextColor: "#757575",
    fontFamily: "Arial, sans-serif",
    buttonTextColor: "#FFFFFF",
    buttonBorderRadius: "20px",
    emailSender: "businesscardsbotswana@gmail.com",
  },
};

export default companies;
